"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const workflows_1 = require("./workflows");
const users_1 = require("./users");
exports.workflowRunDetailData = graphql_tag_1.default `
  fragment workflowRunDetailData on WorkflowRun {
    id
    status
    edited
    runDateTime
    proofSendDateTime
    failureReason
    resourceUrl
    ranByUser {
      ...basicUserDetailData
    }
    workflow {
      id
      name
      archived
      nextWorkflowRun {
        id
      }
    }
  }
  ${users_1.basicUserDetailData}
`;
exports.workflowRunExpandedDetailData = graphql_tag_1.default `
  fragment workflowRunExpandedDetailData on WorkflowRun {
    ...workflowRunDetailData
    workflowMeta {
      ...workflowDetailData
    }
  }
  ${exports.workflowRunDetailData}
  ${workflows_1.workflowDetailData}
`;
exports.workflowRunExpandedDetailDataWithHtml = graphql_tag_1.default `
  fragment workflowRunExpandedDetailDataWithHtml on WorkflowRun {
    ...workflowRunDetailData
    workflowMeta {
      ...workflowDetailData
      email {
        html
      }
    }
  }
  ${exports.workflowRunDetailData}
  ${workflows_1.workflowDetailData}
`;
//# sourceMappingURL=workflowRuns.js.map